var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.params.data &&
      _vm.params.data.is_subscription_expired &&
      _vm.params.data.is_subscription_expired
    )?_c('div',[_c('v-tooltip',{attrs:{"right":"","color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('v-icon',{staticClass:"pr-3 red--text"},[_vm._v(" mdi-information ")])],1)]}}],null,false,456264688)},[_c('span',{staticClass:"text-capitalize"},[_vm._v("The Subscription has expired!")])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }